import { render, staticRenderFns } from "./InventoryItemRound.vue?vue&type=template&id=18bd7576&"
import script from "./InventoryItemRound.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemRound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports